import styled from "styled-components";

export const StyledLanguageSkillsSection = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  box-sizing: border-box;
  gap: 20px;
  height: 740px;

  & .input-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
  }

  & .toggle-row {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 12px;
  }
`;

export const StyledLanguageSkillsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
`;

export const StyledLanguageSkillsFooter = styled.div`
  padding-right: 20px;
`;
